"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const modal = document.querySelectorAll('[data-gs1-modal]');
const documentBody = document.querySelector('body');
const infoText = document.querySelectorAll('[rel~="gs1-modal"]');
const gepirToggle = document.querySelector('#acceptDataUsageOnGepir');
if (modal) {
    modal.forEach((item) => {
        item.addEventListener("click", (event) => {
            const currentTarget = event.target;
            if (currentTarget.classList.contains('modal') || currentTarget.classList.contains('modal__inner-icon')) {
                const documentBlocker = document.querySelector('.modal__blocker');
                const el = event.target;
                const uiBlocker = document.querySelector('.modal__blocker');
                (el.classList.contains('modal__inner-icon')) ? item.classList.add('hidden') : '';
                (el.classList.contains('modal__inner-icon')) ? documentBlocker.remove() : '';
                (uiBlocker) ? uiBlocker.remove() : '';
                item.classList.add('hidden');
            }
        });
        item.addEventListener("keydown", (event) => {
            const uiBlocker = document.querySelector('.modal__blocker');
            if (event.key === "Escape") {
                (uiBlocker) ? uiBlocker.remove() : '';
                item.classList.add("hidden");
            }
        });
    });
    // Toggle info texts in product comparison table
    if (infoText) {
        infoText.forEach((item) => {
            item.addEventListener("click", (event) => {
                event.preventDefault();
                const el = event.target;
                const anchorElement = event.currentTarget;
                const anchor = el.parentElement.parentElement;
                const infoTextModal = document.getElementById(`${(anchorElement != anchor) ? anchorElement.hash.split('#')[1] : anchor.hash.split('#')[1]}`);
                (infoTextModal.classList.contains('hidden')) ? infoTextModal.classList.remove('hidden') : '';
                const documentBlocker = document.createElement('div');
                documentBlocker.classList.add('modal__blocker');
                (documentBlocker) ? documentBody.appendChild(documentBlocker) : '';
                (el.classList.contains('modal__inner-icon')) ? item.classList.add('hidden') : '';
                (el.classList.contains('modal__inner-icon')) ? documentBlocker.remove() : '';
            });
        });
    }
    // Since Verified by GS1 acceptance is a checkbox and not connected to an info-Text icon (see above), it needs to be handled differently.
    if (gepirToggle) {
        gepirToggle.addEventListener("click", (event) => {
            const el = event.target;
            const infoBoxGepirToggle = document.querySelector('#info_gepirStatusToggle');
            if (!el.checked) {
                (infoBoxGepirToggle.classList.contains('hidden')) ? infoBoxGepirToggle.classList.remove('hidden') : '';
                const documentBlocker = document.createElement('div');
                documentBlocker.classList.add('modal__blocker');
                (documentBlocker) ? documentBody.appendChild(documentBlocker) : '';
            }
        });
    }
}
// Since global alerts need the modal we'll just leave this one here for now as well.
const globalAlert = document.querySelector('.js-global-alert');
if (globalAlert) {
    const globalAlertHeight = globalAlert.clientHeight;
    (globalAlertHeight !== 0) ? documentBody.style.marginTop = `${globalAlertHeight}px` : '';
    const globalAlertModalTrigger = globalAlert.querySelector('[data-gs1-global-alert]');
    if (globalAlertModalTrigger) {
        globalAlertModalTrigger.addEventListener("click", (event) => {
            const el = event.target;
            const globalAlertModal = document.querySelector('.global-alert-modal');
            (globalAlertModal.classList.contains('hidden')) ? globalAlertModal.classList.remove('hidden') : globalAlertModal.classList.add('hidden');
            const documentBlocker = document.createElement('div');
            documentBlocker.classList.add('modal__blocker');
            (documentBlocker) ? documentBody.appendChild(documentBlocker) : '';
        });
    }
}
const gs1Alert = document.querySelector('[data-gs1-alert]');
if (gs1Alert) {
    const dismissableIcon = document.querySelector('.alert__dismissable');
    if (dismissableIcon) {
        dismissableIcon.addEventListener("click", (event) => {
            const el = event.target;
            (el) ? gs1Alert.parentElement.remove() : '';
        });
    }
}
exports.default = {};
